import React, { Component } from "react";
import { Link } from 'react-router-dom';
import GravityForm from "react-gravity-form";

export default class PageFooter extends Component {
	
	render () {
		
		let post = this.props.post;
		
		if (post) {
			
			let phoneEmail = '<p>';
			if (post.ftr_phone && post.ftr_phone_url) {
				phoneEmail = phoneEmail + '<a href="tel:' + post.ftr_phone_url + '">' + post.ftr_phone + '</a><br />';
			}
			if (post.ftr_email) {
				phoneEmail = phoneEmail + '<a href="tel:' + post.ftr_email + '">' + post.ftr_email + '</a>';
			}
			phoneEmail = phoneEmail + '</p>';
			
			let address = '<p>';
			if (post.ftr_address && post.ftr_google_maps_url) {
				address = address + '<a href="tel:' + post.ftr_google_maps_url + '">' + post.ftr_address + '</a>';
			} else if (post.ftr_address) {
				address = address + post.ftr_address;
			}
			address = address + '</p>';
			
			let instagram = '<p>';
			if (post.ftr_instagram_handle && post.ftr_instagram_url) {
				instagram = instagram + '<a href="' + post.ftr_instagram_url + '" target="_blank">' + post.ftr_instagram_handle + '</a>';
			}
			instagram = instagram + '</p>';
				   
		    return (

				<div className="c-footer c-load">
				
					<div className="c-footer__inner">
		    		
			    		<div className="c-footer__section c-footer__section--top">
			    			
			    			<div className="l-content">
			    			
			    				<div className="l-grid">
			    				
									<div className="l-grid__col l-grid__col--m-4-12 l-grid__col--l-6-12">
										<h3 className="c-paragraph c-paragraph--small c-paragraph--heading" dangerouslySetInnerHTML={ {__html:post.ftr_contact_heading}}></h3>
									</div>
									
									<div className="l-grid__col l-grid__col--m-8-12 l-grid__col--l-6-12">
										<div className="scope-text scope-text--small" dangerouslySetInnerHTML={ {__html:post.ftr_contact_text}}></div>
									</div>
									
								</div>
								
							</div>
							
						</div>
							
						<div className="c-footer__section c-footer__section--middle">
			    			
			    			<div className="l-content">
			    			
			    				<div className="l-grid">
			    				
									<div className="l-grid__col l-grid__col--m-4-12 l-grid__col--l-6-12"></div>
									
									<div className="l-grid__col l-grid__col--m-8-12 l-grid__col--l-6-12">
										<div className="c-footer__contact">
											<div className="c-footer__contact__section">
												<div className="scope-text scope-text--small" dangerouslySetInnerHTML={ {__html:phoneEmail}}></div>
											</div>
											
											<div className="c-footer__contact__section">
												<div className="scope-text scope-text--small" dangerouslySetInnerHTML={ {__html:address}}></div>
											</div>
											
											<div className="c-footer__contact__section">
												<div className="scope-text scope-text--small" dangerouslySetInnerHTML={ {__html:instagram}}></div>
											</div>
										</div>
									</div>
									
								</div>
								
							</div>
							
						</div>
							
						<div className="c-footer__section c-footer__section--bottom"></div>
						
					</div>
		    				
				</div>
			)
			
		} else {
			
			return false;
			
		}
		
	}
			
}
